import * as Yup from 'yup';

const vehicleFiltersSchema = Yup.object({
  reg: Yup.mixed()
    .nullable()
    .label('Rekisterinumero'),
  customer_id: Yup.number()
    .nullable()
    .label('Omistaja'),
  kilometers: Yup.number()
    .nullable()
    .label('Kilometrit'),
  search: Yup.mixed()
    .nullable()
    .label('Vapaa haku')
});

export default vehicleFiltersSchema;
export type VehicleFiltersSchema = ReturnType<typeof vehicleFiltersSchema.cast>;
